module.exports = __webpack_public_path__ + "img/x_ray_4.580ded69.png";